import { connect } from 'react-redux'
import { checkJiaBanYC } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkJiaBanYC
}
const mapStateToProps = (state) => {
  return {
    ...state.JiaBanYCCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
